// extracted by mini-css-extract-plugin
module.exports = {"bodyLink":"BodyLink_bodyLink__1t6kM","titleLink":"BodyLink_titleLink__3W65Y","btnLink":"BodyLink_btnLink__R1_Io"};